import Rete from 'rete';
import {RemoveButton} from "./components/RemoveButton";

export class RemoveButtonControl extends Rete.Control {

    constructor(emitter, key, node, readonly = false, onRemoveClick) {
        super(key);
        this.emitter = emitter;
        this.key = key;
        this.component = props => (
            <RemoveButton {...props} />
        );
        this.state = {
            answers: [],
        }

        this.props = {
            readonly,
            onRemoveClick: onRemoveClick,
            data: node.data
        };
    }
}